import { useEffect, useRef } from "react";
import styles from "./css/BB8LoadingPage.module.css";

const BB8LoadingPage = () => {
    const canvasRef = useRef(null);
    const lasers = useRef([]);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        ctx.fillStyle = "black";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const interval = setInterval(() => {
            if (Math.random() < 0.5) {
                lasers.current.push({
                    x: canvas.width,
                    y: Math.floor(Math.random() * canvas.height),
                    length: Math.floor(Math.random() * 200) + 50,
                });
            }
        }, 100);

        const draw = () => {
            ctx.fillStyle = "black";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            ctx.strokeStyle = "red";
            ctx.lineWidth = 6;
            ctx.lineCap = "round";

            for (let i = 0; i < lasers.current.length; i++) {
                const laser = lasers.current[i];
                ctx.beginPath();
                ctx.moveTo(laser.x, laser.y);
                ctx.lineTo(laser.x - laser.length, laser.y);
                ctx.stroke();

                laser.x -= 40;
                if (laser.x < -laser.length) {
                    lasers.current.splice(i, 1);
                    i--;
                }
            }

            requestAnimationFrame(draw);
        };

        draw();

        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <div className={styles.loader}>
                <div className={styles.droid}>
                    <div className={styles.radios}>
                        <div
                            className={`${styles.radio} ${styles.short}`}
                        ></div>
                        <div className={`${styles.radio} ${styles.long}`}></div>
                    </div>
                    <div className={styles.head}>
                        <div className={`${styles.band} ${styles.one}`}></div>
                        <div className={`${styles.band} ${styles.two}`}></div>
                        <div className={styles.eyes}>
                            <div
                                className={`${styles.eye} ${styles.one}`}
                            ></div>
                            <div
                                className={`${styles.eye} ${styles.two}`}
                            ></div>
                        </div>
                        <div className={`${styles.band} ${styles.three}`}></div>
                    </div>
                    <div className={styles.body}>
                        <div className={`${styles.lines} ${styles.one}`}></div>
                        <div className={`${styles.lines} ${styles.two}`}></div>
                        <div className={`${styles.circle} ${styles.one}`}></div>
                        <div className={`${styles.circle} ${styles.two}`}></div>
                        <div
                            className={`${styles.circle} ${styles.three}`}
                        ></div>
                    </div>
                </div>
                <div className={styles.text}>
                    <span>LOADING</span>
                </div>
            </div>
            <canvas ref={canvasRef}></canvas>
        </>
    );
};

export default BB8LoadingPage;
